import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IManagementCompanyFullSchema } from '../../repositories/bti/entities/management_companies/ManagementCompanyFullSchema';

export enum EActionTypes {
  SetManagementCompany = 'valuation/SetManagementCompany',
}

export const setManagementCompany = actionGenerator<EActionTypes.SetManagementCompany, IManagementCompanyFullSchema>(
  EActionTypes.SetManagementCompany,
);

export type TManagementCompanyActions = ReturnType<typeof setManagementCompany>;
